import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-info__items" }

import {
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { bankList } from '../../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-bank',
  setup(__props) {

const { formData, payPassagewayCode } = storeToRefs(infoStore());

const bankRemote = async name => {
  const resp = await bankList({
    name,
    payPassagewayCode: payPassagewayCode.value
  });
  return resp;
};

const onBankChange = (val, [option]) => {
  formData.value.openBankName = option ? option.bankName : null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode("银行信息")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), { class: "account-info__content" }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseFormItem), {
          label: "开户银行",
          prop: "openBankNode",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              placeholder: "请选择",
              "label-key": "bankName",
              "value-key": "bankCode",
              init: "",
              clearable: "",
              filterUseRemote: "",
              modelValue: _unref(formData).openBankNode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).openBankNode) = $event)),
              remoteMethod: bankRemote,
              remoteSelected: [
            {
              bankCode: _unref(formData).openBankNode,
              bankName: _unref(formData).openBankName
            }
          ],
              onChange: onBankChange
            }, null, 8, ["modelValue", "remoteSelected"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开户名",
          prop: "openName",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).openName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).openName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "银行账号",
          prop: "openBankNumber",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              clearable: "",
              modelValue: _unref(formData).openBankNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).openBankNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})